import { useCallback } from "react";
import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export const useDeleteSuppliers = () => {
  const [deleteSupplier] = useAPIAction(
    SuppliersApi,
    async (api, id: string) => {
      const data = await api.supplierDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "managesuppliers.actions.delete",
    }
  );

  return useCallback(
    async (supplierIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const supplierId of supplierIds) {
        try {
          await deleteSupplier(supplierId);
          successfullyDeleted.push(supplierId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteSupplier]
  );
};
